import { render } from "./SupplierCreate.vue?vue&type=template&id=58d60109"
import script from "./SupplierCreate.vue?vue&type=script&lang=js"
export * from "./SupplierCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__